import React from 'react';
import { Sector } from '../../types/sector';
import styles from '../../styles/shared/CardGrid.module.css';

interface SectorCardProps {
  sector: Sector;
  onEdit: (sector: Sector) => void;
  onDelete: (sectorId: number) => void;
  onViewProducts: (sectorId: number) => void;
  canEdit?: boolean;
}

const SectorCard: React.FC<SectorCardProps> = ({ sector, onEdit, onDelete, onViewProducts, canEdit = true }) => {
  const sectorName = sector.sector_name;
  const imageUrl = sector.image_url;

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={sectorName}
            className={styles.cardImage}
            onError={(e) => {
              e.currentTarget.src = '/placeholder-sector.jpg';
            }}
          />
        ) : (
          <div className={styles.placeholderImage}>
            <span>🏭</span>
          </div>
        )}
      </div>
      
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{sectorName}</h3>
        
        <div className={styles.cardActions}>
          <button 
            onClick={() => onViewProducts(sector.id)} 
            className={`${styles.cardActionButton} ${styles.cardViewButton}`}
          >
            View Products
          </button>
          {canEdit && (
            <>
              <button 
                onClick={() => onEdit(sector)} 
                className={`${styles.cardActionButton} ${styles.cardEditButton}`}
              >
                Edit
              </button>
              <button 
                onClick={() => onDelete(sector.id)} 
                className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
              >
                Delete
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectorCard; 